<div class="flex flex-col bg-card overflow-hidden">
  <div class="light:bg-cool-gray-100 dark:bg-cool-gray-700 pl-3 pr-3 pt-2 pb-2 border-b flex items-center">
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="property" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div *ngIf="!changeTitleMode" class="font-bold text-md text-secondary uppercase tracking-wider">
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto">
      <!-- Save button -->
      <button
        mat-icon-button
        type="button"
        *ngIf="!changeTitleMode"
        [matTooltip]="'Add Contact'"
        #addContactPanelOrigin
        (click)="openContactModal()"
        [appAuthorize]="[NewPermission.PROPERTIES_EDIT, property.permissions?.is_editable]"
        denyAction="disable"
      >
        <mat-icon [svgIcon]="'add_circle'"></mat-icon>
      </button>

      <ng-container *ngIf="canEditPanelDef">
        <button mat-icon-button type="button" *ngIf="!changeTitleMode" [matMenuTriggerFor]="listCardMenu">
          <mat-icon class="icon-size-20" [svgIcon]="'more_vert'"></mat-icon>
        </button>
        <mat-menu #listCardMenu="matMenu">
          <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
            <mat-icon [svgIcon]="'edit'"></mat-icon>
            Change Panel Heading
          </button>
        </mat-menu>
        <button mat-icon-button *ngIf="changeTitleMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
          <mat-icon [svgIcon]="'save'"></mat-icon>
        </button>
      </ng-container>
      <ng-template #addContactPanel>
        <div class="custom-field-panel">
          <div class="custom-field-panel-header">
            <div class="title">Add or Select Contact</div>
          </div>

          <div class="content">
            <form [formGroup]="contactForm">
              <div class="grid grid-cols-2 gap-4">
                <div class="row">
                  <input [formControlName]="'id'" type="hidden" />
                  <mat-form-field class="treo-mat-no-subscript">
                    <mat-label>Contact Name</mat-label>
                    <input
                      matInput
                      [formControlName]="'name'"
                      [placeholder]="'Contact Name or Company Name'"
                      [matAutocomplete]="matAutocomplete"
                      [spellcheck]="false"
                    />
                  </mat-form-field>
                  <mat-autocomplete
                    #matAutocomplete="matAutocomplete"
                    [disableRipple]="true"
                    (optionSelected)="autocompleteSelected($event)"
                  >
                    <mat-option class="no-results" *ngIf="results && !results.length"> No results found! </mat-option>

                    <mat-option *ngFor="let result of results" [value]="result">
                      {{ result.name }} ({{ result.category_name }})
                    </mat-option>
                  </mat-autocomplete>
                </div>

                <div class="row">
                  <mat-form-field class="treo-mat-no-subscript">
                    <mat-label>Contact Type</mat-label>
                    <mat-select [formControlName]="'category_id'">
                      <mat-option *ngFor="let category of categories" [value]="category.id">
                        {{ category.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Title -->
                <div class="row">
                  <mat-form-field class="field treo-mat-no-subscript">
                    <mat-label>Company</mat-label>
                    <input matInput [formControlName]="'company_name'" [placeholder]="'Company Name'" />
                  </mat-form-field>
                </div>

                <div class="row">
                  <mat-form-field class="field treo-mat-no-subscript">
                    <mat-label>Email</mat-label>
                    <input matInput [formControlName]="'email'" [placeholder]="'Email'" />
                  </mat-form-field>
                </div>

                <div class="row">
                  <mat-form-field class="field treo-mat-no-subscript">
                    <mat-label>Phone</mat-label>
                    <input matInput [formControlName]="'phone'" [placeholder]="'Phone'" digitOnly />
                  </mat-form-field>
                </div>
              </div>

              <!-- Actions -->
              <button
                class="add"
                mat-flat-button
                type="submit"
                [disabled]="contactForm.pristine || contactForm.invalid"
                (click)="saveContactAssociation()"
                [color]="'primary'"
              >
                Save
              </button>
            </form>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="flex flex-col p-8">
    <div class="emails" *ngIf="contactsCount > 0; else EmptyContactsAssociation">
      <!-- View -->
      <div class="view">
        <ng-container *ngFor="let contact of contacts; let i = index; trackBy: trackByFn">
          <div class="email">
            <div>
              <div class="address">
                <div class="font-medium leading-none">
                  <mat-icon class="icon-size-20 mr-3" [svgIcon]="'account_circle'"></mat-icon>
                  <a [routerLink]="['/contacts/' + contact.id]">{{ contact.name }}</a> [{{ contact.category_name }}]
                  <span *ngIf="contact.company_name">at {{ contact.company_name }}</span>
                </div>
              </div>
              <div
                class="text-md leading-none text-secondary mt-2"
                *ngIf="contact.email"
                (click)="openContactSendMessageModal(contact)"
              >
                <mat-icon class="icon-size-20 mr-3" [svgIcon]="'email'"></mat-icon> {{ contact.email }}
              </div>
              <div class="text-md leading-none text-secondary mt-2" *ngIf="contact.phone">
                <mat-icon class="icon-size-20 mr-3" [svgIcon]="'call'"></mat-icon>
                <a href="tel:{{ contact.phone }}">{{ contact.phone | phone }}</a>
              </div>
            </div>
            <div class="actions">
              <button
                class="remove-email-field"
                type="button"
                mat-icon-button
                (click)="openContactModal(contact.id)"
                matTooltip="Edit"
                [appAuthorize]="[NewPermission.PROPERTIES_EDIT, property.permissions?.is_editable]"
              >
                <mat-icon [svgIcon]="'edit'"></mat-icon>
              </button>
              <button
                class="remove-email-field"
                type="button"
                mat-icon-button
                (click)="removeEmailField(i, contact.id)"
                matTooltip="Remove"
                [appAuthorize]="[NewPermission.PROPERTIES_EDIT, property.permissions?.is_editable]"
              >
                <mat-icon [svgIcon]="'cancel'"></mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #EmptyContactsAssociation>
  <div class="flex flex-col items-center justify-center h-full">
    <mat-icon class="icon-size-40" [svgIcon]="'account_circle'"></mat-icon>
    <p class="text-2xl text-secondary font-medium mt-4">No Contacts Associated</p>
    <p class="text-sm text-secondary mt-2">Add contacts to this panel to associate them.</p>
  </div>
</ng-template>
